<div class="modal-header">
    <h3 class="modal-title">
        Add Field Ticket Day
    </h3>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-5">
            <ng-select name="selectedLocation"
                        [(ngModel)]="selectedValue"
                        [searchable]="true">
                <ng-option *ngFor="let templateDate of (templateDates | excludeFrom: '!selected')" [value]="templateDate">
                    <span [innerHtml]="templateDate.DateValue"></span>
                </ng-option>
            </ng-select>
        </div>
        <div class="col-md-1">
            <button type="button" class="btn btn-primary"
                    (click)="addValue()">
                Add To Timecard
            </button>
        </div>
    </div>
    <div class="row" style="margin-top:10px;">
        <table class="table">
            <tbody>
                <tr *ngFor="let templateDate of (templateDates | excludeFrom:'selected')">
                    <td>{{templateDate.DateValue}} <button type="button" class="button-link" (click)="deleteValue(templateDate)">remove</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>

